import { axiosClient } from './AxiosClient'

function listFloor(callback, errorCallback){
    const url = '/information/floor/list'
    axiosClient.get(url)
    .then((response) => {
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function createFloor(floorName, callback, errorCallback){
    const url = '/information/floor/create'

    var formData = new FormData()
    formData.append("floor_name", floorName)
    axiosClient.post(url, formData)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function deleteFloor(floorId, callback, errorCallback){
    const url = '/information/floor/delete'

    var formData = new FormData()
    formData.append("floor_id", floorId)
    axiosClient.post(url, formData)
    .then((response)=>{
        callback(response.data)
    })
    .catch((error) => {
        errorCallback(error)
    })
}

function viewFloor(floorId){
    return new Promise((resolve, reject) => {
        const url = `/rental/floor/view/${floorId}`
        axiosClient.get(url)
        .then((response) => {
            resolve(response.data)
        })
        .catch((error) => {
            reject(error)
        })
    })
}

function addArea(areaDesc, areaSize, maxLease, floorId){
    return new Promise((resolve, reject) => {
        const url = `/rental/area/create`
        let formData = new FormData()
        formData.append("floor_id", floorId)
        formData.append("area_desc", areaDesc)
        formData.append("area_size", areaSize)
        formData.append("max_lease", maxLease)
        axiosClient.post(url, formData)
        .then(() => {
            resolve()
        })
        .catch((error) => {
            reject(error)
        })
    })
}

export {
    listFloor,
    createFloor,
    deleteFloor,
    viewFloor,
    addArea
}